import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  dicMap: new Map()
};
const mutations = {
  mapDicData(state, data) {
    console.log(data);
    state.dicMap.set(data.type, data.dictItemList);
  }
};

import layoutStore from "./layoutStore.js"; //公共状态
import consignor from "./consignor"; //委托方
import organization from "./organization"; //作业方
import cases from "./cases/index";
import reportDownload from "./reportDownload/index";

import address from "./address.js"; //全国地址

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    layoutStore,
    consignor,
    organization,
    cases,
    reportDownload,
    address
  }
});
